import { render, staticRenderFns } from "./MakeAppointment.vue?vue&type=template&id=e05f8d2c&scoped=true&"
import script from "./MakeAppointment.vue?vue&type=script&lang=js&"
export * from "./MakeAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05f8d2c",
  null
  
)

export default component.exports